import { forEach } from 'lodash';
import anime from 'animejs';
import $ from 'shared/$';
import events from 'utils/events';

export default class MegaNav {
  constructor(root, hasSticky) {
    // this.header = document.querySelector('.u-nav-header, [class*="u-nav-header--"]');
    this.root = root;
    this.placeholder = document.querySelector('.u-nav-header-placeholder');
    this.topbar = document.querySelector('.topbar');
    this.level0 = this.root.querySelectorAll('li.has-mega > a');
    this.isOpen = false;
    this.isStickable = false;
    this.headerNodes = ['.u-nav-portal', '.u-nav-header-placeholder', '.u-nav-header', '.topbar'];
    this.stickyHeightOffset = this.getHeaderNodesHeight();

    if (this.level0.length === 0) {
      return { empty: true };
    }

    // Init mega menu
    if (document.querySelector('.u-nav-mega')) {
      this.mega = document.querySelector('.u-nav-mega');
    } else {
      this.mega = document.createElement('div');
      this.mega.setAttribute('id', 'u-nav-mega');
      this.mega.classList.add('u-nav-mega');

      if (this.root.matches('[class*="u-nav-portal"]')) {
        this.mega.classList.add('u-nav-mega--portal');
      }

      if (this.root.matches('[class*="u-nav-site"]')) {
        this.mega.classList.add('u-nav-mega--site');

        // If root site-nav with sticky…
        if (hasSticky) {
          this.isStickable = hasSticky;
          this.topSticky = this.stickyHeightOffset.sticky;
          this.topUnsticky = this.stickyHeightOffset.fixed;

          this.mega.style.top = `${this.topUnsticky}px`;
          if (this.placeholder.classList.contains('active')) {
            this.stick();
          }
          this.mega.classList.add('is-stickable');
        }
      }

      // document.body.appendChild(this.mega);
      document.querySelector('.u-body').appendChild(this.mega);
    }

    this.bind();
  }

  get top() {
    return $.offset(this.root).top + this.root.offsetHeight;
  }

  bind() {
    this.onClick = this.click.bind(this);
    this.onClickOutside = this.clickOutside.bind(this);
    this.onResize = this.resize.bind(this);
    this.onStick = this.stick.bind(this);
    this.onUnstick = this.unstick.bind(this);

    document.addEventListener('click', this.onClickOutside);

    forEach(this.level0, a => {
      a.addEventListener('click', this.onClick);
    });

    window.addEventListener('resize', this.onResize);

    if (this.isStickable) {
      events.on(events.STICK, this.onStick);
      events.on(events.UNSTICK, this.onUnstick);
    }
  }

  destroy() {
    document.removeEventListener('click', this.onClickOutside);

    forEach(this.level0, a => {
      a.removeEventListener('click', this.onClick);
    });

    window.removeEventListener('resize', this.onResize);

    if (this.isStickable) {
      events.off(events.STICK, this.onStick);
      events.off(events.UNSTICK, this.onUnstick);
    }

    this.emptyMega();
    this.isOpen = false;
  }

  click(e) {
    const target = e.currentTarget;
    const li = target.parentNode;
    const level = li.querySelector('.u-nav-level[data-nav-level="1"]');

    if (level && !level.classList.contains('is-open')) {
      e.preventDefault();
      this.openLevel(level);
    } else {
      e.preventDefault();
      this.closeMega();
      this.closeAll();
    }
  }

  getHeaderNodesHeight() {
    const fixed = this.headerNodes.reduce((totalHeight, node) => {
      node = document.querySelector(node);

      if (node) {
        totalHeight += node.offsetHeight;
      }

      return totalHeight - 1; // 1 -> wired 1px spacing between megamenu and header
    }, 0);

    const header = document.querySelector('.u-nav-header');
    const offsetHeight = header ? header.offsetHeight : 0;
    const sticky = this.topbar ? offsetHeight : offsetHeight - 40; // 40 -> topbar height

    return {
      fixed,
      sticky,
    };
  }

  clickOutside(e) {
    if (!this.isOpen) {
      return;
    }

    let el = e.target;
    let isNav = el => {
      return el && el.classList && (el.classList.contains('u-nav-mega') || el.classList.contains('has-mega'));
    };

    while (el && !isNav(el)) {
      el = el.parentNode;
    }

    if (!isNav(el)) {
      this.closeAll();
      this.closeMega();
    }
  }

  resize() {
    if (this.isOpen) {
      this.level.style.height = 'auto';
      const levelHeight = this.level.offsetHeight;
      this.level.style.height = `${levelHeight}px`;
      this.mega.style.height = `${levelHeight}px`;
    }
  }

  stick() {
    console.info('stick');
    // this.setTop(100);
    this.mega.style.top = `${this.topSticky}px`;
    this.mega.style.position = 'fixed';
    // this.mega.classList.add('is-sticky');
  }

  unstick() {
    console.info('unstick');
    // this.setTop(this.top, true);
    this.mega.style.top = `${this.topUnsticky}px`;
    this.mega.style.position = 'absolute';
    // this.mega.classList.remove('is-sticky');
  }

  setTop(y, unstick = false) {
    this.mega.style.top = `${y}px`;
    // const anim = anime({
    //   targets: this.mega,
    //   top: y,
    //   duration: 150,
    //   easing: 'easeOutQuad',
    // });

    // if (unstick) {
    //   anim.finished.then(() => {
    //     this.mega.classList.remove('is-sticky');
    //   });
    // }
  }

  closeAll() {
    const siblings = this.root.querySelectorAll('.u-nav-level[data-nav-level="1"]');

    forEach(siblings, s => {
      this.closeLevel(s);
    });
  }

  closeLevel(level) {
    level.classList.remove('is-open');
    level.previousElementSibling.classList.remove('has-open');
  }

  openLevel(level) {
    if (this.isAnimate) {
      return;
    }

    this.closeAll();

    level.classList.add('is-open');
    level.previousElementSibling.classList.add('has-open');

    const cloneLevel = level.cloneNode(true);
    cloneLevel.style.display = 'block';

    this.level = cloneLevel;

    if (!this.isAnimate) {
      if (this.isOpen) {
        this.updateMega(cloneLevel);
      } else {
        this.openMega(cloneLevel);
      }
    }
  }

  openMega(level) {
    this.isOpen = true;
    this.isAnimate = true;
    this.mega.appendChild(level);
    document.body.classList.add('menu-open');

    // Content is in absolute position
    // so we need to grab height
    const h = level.offsetHeight;
    this.mega.style.transform = `translateY(-${h + 20}px)`; // Init for animejs
    this.mega.style.height = `${h + 100}px`;

    const anim = anime({
      targets: this.mega,
      translateY: 0,
      duration: 500,
      easing: 'easeOutQuad',
    });

    anim.finished.then(() => {
      this.isAnimate = false;
    });
  }

  static clipRect(clip) {
    return `rect(${clip.top}px, ${clip.right}px, ${clip.bottom}px, ${clip.left}px)`;
  }

  updateMega(level) {
    this.isAnimate = true;
    const old = this.mega.querySelector('.u-nav-level[data-nav-level="1"]');
    const oldNav = old.querySelector('nav[data-nav-level="1"]');
    const oldCard = old.querySelector('.u-nav-card');

    const lvlNav = level.querySelector('nav[data-nav-level="1"]');
    const lvlCard = level.querySelector('.u-nav-card');

    level.style.opacity = 0;
    level.style.position = 'absolute';
    lvlNav.style.opacity = 0;

    this.mega.appendChild(level);
    const h = level.offsetHeight;
    const tl = anime.timeline();

    // Links animation (fadeOut)
    tl.add({
      targets: oldNav,
      opacity: 0,
      duration: 250,
      easing: 'easeInQuad',
    });

    // u-card animation (clip)
    if (oldCard) {
      oldCard.style.height = `${oldCard.offsetHeight}px`;

      const oldImg = old.querySelector('.u-card__cover img');
      const oldImgWidth = oldImg.offsetWidth;
      const oldImgHeight = oldImg.offsetHeight;
      const oldImgClip = {
        top: 0,
        right: oldImgWidth,
        bottom: oldImgHeight,
        left: 0,
      };
      const oldBlock = old.querySelector('.u-card__content');
      const oldBlockHeight = oldBlock.offsetHeight;
      const oldBlockWidth = oldBlock.offsetWidth;
      const oldBlockMargin = window.getComputedStyle(oldBlock, null).getPropertyValue('margin-left');
      const oldBlockClip = {
        top: 0,
        right: oldBlockWidth,
        bottom: oldBlockHeight,
        left: 0,
      };
      oldBlock.style.left = oldBlockMargin;
      oldBlock.style.position = 'absolute';

      tl.add({
        targets: oldImgClip,
        left: oldImgWidth,
        duration: 350,
        offset: 0,
        easing: 'easeInQuad',
        update() {
          oldImg.style.clip = MegaNav.clipRect(oldImgClip);
        },
      }).add({
        targets: oldBlockClip,
        left: oldBlockWidth,
        duration: 350,
        offset: 50,
        easing: 'easeInQuad',
        update() {
          oldBlock.style.clip = MegaNav.clipRect(oldBlockClip);
        },
      });
    }

    // Mega menu animation (height)
    tl.add({
      targets: this.mega,
      height: h,
      duration: 200,
      offset: '-=25',
      easing: 'easeInOutQuad',
    });

    // u-card animation (clip)
    if (lvlCard) {
      lvlCard.style.height = `${lvlCard.offsetHeight}px`;

      const lvlImg = level.querySelector('.u-card__cover img');
      const lvlImgWidth = lvlImg.offsetWidth;
      const lvlImgHeight = lvlImg.offsetHeight;
      const lvlImgClip = {
        top: 0,
        right: 0,
        bottom: lvlImgHeight,
        left: 0,
      };
      lvlImg.style.clip = MegaNav.clipRect(lvlImgClip);

      const lvlBlock = level.querySelector('.u-card__content');
      const lvlBlockHeight = lvlBlock.offsetHeight;
      const lvlBlockWidth = lvlBlock.offsetWidth;
      const lvlBlockMargin = window.getComputedStyle(lvlBlock, null).getPropertyValue('margin-left');
      const lvlBlockClip = {
        top: 0,
        right: 0,
        bottom: lvlBlockHeight,
        left: 0,
      };
      lvlBlock.style.left = lvlBlockMargin;
      lvlBlock.style.position = 'absolute';
      lvlBlock.style.clip = MegaNav.clipRect(lvlBlockClip);

      tl.add({
        targets: lvlImgClip,
        right: lvlImgWidth,
        duration: 550,
        offset: '-=50',
        easing: 'easeOutQuad',
        update() {
          lvlImg.style.clip = MegaNav.clipRect(lvlImgClip);
        },
      }).add({
        targets: lvlBlockClip,
        right: lvlBlockWidth,
        duration: 550,
        offset: '-=100',
        easing: 'easeOutQuad',
        update() {
          lvlBlock.style.clip = MegaNav.clipRect(lvlBlockClip);
        },
      });
    }

    level.style.opacity = 1;

    // Links animation (fadeIn)
    tl.add({
      targets: lvlNav,
      opacity: 1,
      duration: 200,
      offset: '-=150',
      easing: 'easeOutQuad',
    });

    tl.finished.then(() => {
      this.mega.removeChild(old);
      if (lvlCard) {
        const lvlImg = level.querySelector('.u-card__cover img');
        const lvlBlock = level.querySelector('.u-card__content');
        // Clear lvlImg
        lvlImg.style.clip = '';
        // Clear lvlBlock
        lvlBlock.style.clip = '';
        lvlBlock.style.left = '';
        lvlBlock.style.position = 'relative';
      }
      this.isAnimate = false;
      console.info('update');
    });
  }

  closeMega() {
    this.isAnimate = true;
    const anim = anime({
      targets: this.mega,
      translateY: -this.mega.offsetHeight - 20,
      duration: 500,
      easing: 'easeInQuad',
    });
    anim.finished.then(() => {
      this.emptyMega();
      // this.removeMega();
      this.isOpen = false;
      this.isAnimate = false;
      document.body.classList.remove('menu-open');
    });
  }

  emptyMega() {
    if (document.querySelector('.u-nav-mega')) {
      // Empty + reset height
      this.mega.innerHTML = '';
      this.mega.style.height = 0;
    }
  }
}
